export function buildTripCostShareUrl(values, origin = window.location.origin) {
  const url = new URL("/share/trip-cost", origin);
  const fields = {
    from: values.fromLabel,
    to: values.toLabel,
    km: values.distanceKm,
    conso: values.consumptionLitersPer100Km,
    fuel: values.fuelPricePerLiter,
    vehicle: values.vehicleCostPerKm,
    tolls: values.tolls,
    people: values.occupants,
    trip: values.tripType === "roundtrip" ? "roundtrip" : undefined,
  };
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) url.searchParams.set(key, String(value));
  });
  return url.toString();
}

export function buildTripCostShareImageUrl(values, origin = window.location.origin) {
  const url = new URL(buildTripCostShareUrl(values, origin));
  url.pathname = "/share/trip-cost/image.png";
  return url.toString();
}

async function fetchShareFile(url, filename) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Impossible de charger l'image (${response.status}).`);
  const blob = await response.blob();
  return new File([blob], filename, { type: blob.type || "image/png" });
}

const preparedShareFiles = new Map();

async function prepareShareFile(imageUrl, filename) {
  if (!imageUrl) return null;
  if (preparedShareFiles.has(imageUrl)) return preparedShareFiles.get(imageUrl);

  try {
    const file = await fetchShareFile(imageUrl, filename);
    preparedShareFiles.set(imageUrl, file);
    while (preparedShareFiles.size > 4) {
      preparedShareFiles.delete(preparedShareFiles.keys().next().value);
    }
    return file;
  } catch {
    return null;
  }
}

function readPreparedShareFile(imageUrl) {
  return preparedShareFiles.get(imageUrl) || null;
}

async function shareWithOptionalImage({ title, text, url, imageUrl }) {
  if (navigator.share) {
    const file = readPreparedShareFile(imageUrl);
    const canShareFile = file && (!navigator.canShare || navigator.canShare({ files: [file] }));
    // Important pour WebKit : navigator.share doit etre appele directement
    // pendant le geste utilisateur, sans fetch/await prealable.
    const sharePromise = navigator.share({
      title,
      text,
      url,
      ...(canShareFile ? { files: [file] } : {}),
    });
    await sharePromise;
    return canShareFile ? "shared-image" : "shared";
  }
  await navigator.clipboard.writeText(url);
  return "copied";
}

export function preloadTripCostShareImage(values) {
  return prepareShareFile(buildTripCostShareImageUrl(values), "mon-trajet-karango.png");
}

export function preloadTripCalculatorShareImage(origin = window.location.origin) {
  return prepareShareFile(
    new URL("/karango-calculateur-promo.png", origin).toString(),
    "karango-calculateur-trajet.png",
  );
}

export async function shareTripCost(values) {
  const url = buildTripCostShareUrl(values);
  return shareWithOptionalImage({
    title: `Mon trajet revient à environ ${values.pricePerPerson} € par personne`,
    text: `${values.fromLabel || "Départ"} → ${values.toLabel || "Destination"} · estimation Karango`,
    url,
    imageUrl: buildTripCostShareImageUrl(values),
    filename: "mon-trajet-karango.png",
  });
}

export async function shareTripCalculator(origin = window.location.origin) {
  const url = new URL("/calculateur-trajet", origin).toString();
  return shareWithOptionalImage({
    title: "Covoiturez, payez moins avec Karango",
    text: "Calcule facilement le coût de ton trajet et partage équitablement les frais avec Karango.",
    url,
    imageUrl: new URL("/karango-calculateur-promo.png", origin).toString(),
    filename: "karango-calculateur-trajet.png",
  });
}
